export const STATUSES = [
  'created',
  'prepared',
  'dispatched',
  'returned',
  'cut',
  'analysing',
  'ready to finalise',
  'finalised',
  'finalising',
  'cancelled',
] as const;

export type TStatus = (typeof STATUSES)[number] | 'submitted' | 'submitting';
